export default "<div class=\"img-ratio-1 button-container\" (click)=\"closeClub()\">\n  <img src=\"assets/images/icons/arrow_back.svg\" alt=\"\">\n</div>\n";